<ion-thumbnail (click)="openImageModal(); $event.stopPropagation()">
  <cdn-img [src]="src" alt="log-picture" size="sm" />
</ion-thumbnail>
